import React, { useState, useEffect } from "react"
import { useAuth } from "../../contexts/AuthContext"

const DISMISS_KEY = "heartily_app_download_dismissed"
const APP_STORE_URL = "https://apps.apple.com/us/app/heartily/id6758560233"

const AppDownloadBanner = () => {
  const { user } = useAuth()
  const [dismissed, setDismissed] = useState(true)

  useEffect(() => {
    // Show banner if user hasn't registered a push device and hasn't dismissed
    if (user && !user.has_push_device) {
      const wasDismissed = localStorage.getItem(DISMISS_KEY)
      if (!wasDismissed) {
        setDismissed(false)
      }
    }
  }, [user])

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1")
    setDismissed(true)
  }

  if (dismissed || !user || user.has_push_device) {
    return null
  }

  return (
    <div className="bg-gradient-to-r from-[var(--ink)] to-[var(--ink-muted)] text-white px-4 py-3">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-9 h-9 bg-white/10 rounded-xl flex items-center justify-center flex-shrink-0">
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
          </div>
          <p className="text-sm font-medium truncate">
            <span className="hidden sm:inline">Get push notifications for due dates and grades. </span>
            <span className="sm:hidden">Get the Heartily iOS app! </span>
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="px-4 py-1.5 bg-white text-[var(--ink)] text-sm font-semibold rounded-lg hover:bg-[var(--cream)] transition-colors"
          >
            Get App
          </a>
          <button
            onClick={handleDismiss}
            className="p-1.5 text-white/60 hover:text-white transition-colors rounded-lg hover:bg-white/10"
            aria-label="Dismiss"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

export default AppDownloadBanner
